module.exports = __webpack_public_path__ + "img/logo.01499b86.png";